import { LitElement, html } from 'lit';
import { customElement, query, state, property } from 'lit/decorators.js';

import '@amityeko/design-system/dist/providers/notification';

import '../../components/recognition-list';
import '../../components/recoginition-list-per-user';
import '../../components/view-recognition-message';
import '../../components/recognition-detail';

import type RnRRecognitionList from '../../components/recognition-list';
import type RnRRecognitionListPerUser from '../../components/recoginition-list-per-user';
import type RnRViewRecognitionMessage from '../../components/view-recognition-message';
import type RnRRecognitionDetail from '../../components/recognition-detail';

@customElement('rnr-page-view-recognitions-on-profile')
export default class RnRPageViewRecognitionsOnProfile extends LitElement {
  @query('#recognition_list_dialog') recognitionListDialog!: RnRRecognitionList;
  @query('#recognition_list_per_user_dialog')
  recognitionListPerUserDialog!: RnRRecognitionListPerUser;
  @query('#view_recognition_message') viewRecognitionMessage!: RnRViewRecognitionMessage;
  @query('#recognition_detail_dialog') recognitionDetailDialog!: RnRRecognitionDetail;

  @property()
  receiverId?: string;

  @property({ type: Number, attribute: 'preview-scale' })
  previewScale?: number;

  @property({ type: Boolean })
  shouldHideButton: boolean = false;

  @state()
  recognitionPerUserBackLocation?: string;

  public showViewRecognition() {
    this.recognitionListDialog.show();
  }

  public onSelectCard(e: CustomEvent) {
    e.stopPropagation();
    this.recognitionListPerUserDialog.show(e?.detail?.data);
    this.recognitionPerUserBackLocation = e?.detail?.from;
  }

  private _onRecognitionPerUserBack() {
    if (this.recognitionPerUserBackLocation === 'top-achievement') return;
    this.recognitionListDialog.show();
  }

  private _onSelectRecognitionItem(e: CustomEvent) {
    this.viewRecognitionMessage.show(e?.detail);
  }

  private _onRecognitionDetailClose() {
    this.viewRecognitionMessage.show();
  }

  private _onViewDetailDialogHide(e: CustomEvent) {
    if (e?.detail?.recognitionId) {
      this.recognitionDetailDialog.show(e.detail.recognitionId);
    } else {
      this.recognitionListPerUserDialog.show();
    }
  }

  protected render() {
    return html`
      <amityeko-notification-provider>
        ${this.shouldHideButton
          ? null
          : html`<amityeko-button @click=${this.showViewRecognition}>Click me!</amityeko-button>`}

        <rnr-recognition-list
          id="recognition_list_dialog"
          .receiverId=${this.receiverId}
          @rnr-recognition-list-select-card=${this.onSelectCard}
        ></rnr-recognition-list>

        <rnr-recognition-list-per-user
          id="recognition_list_per_user_dialog"
          .receiverId=${this.receiverId}
          @rnr-dialog-back=${this._onRecognitionPerUserBack}
          @rnr-select-recognition-item=${this._onSelectRecognitionItem}
        ></rnr-recognition-list-per-user>

        <rnr-view-recognition-message
          id="view_recognition_message"
          .previewScale=${this.previewScale}
          @rnr-on-view-detail-hide=${this._onViewDetailDialogHide}
        ></rnr-view-recognition-message>

        <rnr-recognition-detail
          id="recognition_detail_dialog"
          @rnr-select-recognition-detail-close=${this._onRecognitionDetailClose}
        ></rnr-recognition-detail>
      </amityeko-notification-provider>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'rnr-page-view-recognitions-on-profile': RnRPageViewRecognitionsOnProfile;
  }
}
